export function MasterCardIcon({
    mainClassName,
}) {
    return (
        <svg
            width={24}
            height={16}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={mainClassName}
            viewBox="0 0 24 16"
        >
            <rect width={24} height={16} rx={2} fill="#EBECEE" />
            <path d="M14.159 4.13h-4.33v7.741h4.33v-7.74z" fill="#FF5A00" />
            <path
                d="M10.117 8.001c0-1.573.743-2.968 1.883-3.87a4.938 4.938 0 00-3.052-1.053C6.213 3.078 4 5.28 4 8s2.213 4.923 4.948 4.923a4.938 4.938 0 003.053-1.053 4.905 4.905 0 01-1.884-3.87z"
                fill="#EB001B"
            />
            <path
                d="M20 8.001c0 2.721-2.213 4.923-4.948 4.923A4.938 4.938 0 0112 11.871a4.888 4.888 0 001.883-3.87A4.928 4.928 0 0012 4.131a4.93 4.93 0 013.05-1.053C17.787 3.078 20 5.294 20 8z"
                fill="#F79E1B"
            />
        </svg>
    );
}

export function MirIcon({
    mainClassName,
}) {
    return (
        <svg
            width={24}
            height={16}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={mainClassName}
            viewBox="0 0 24 16"
        >
            <rect width={24} height={16} rx={2} fill="#EBECEE" />
            <path
                d="M16.329 7.728v3.11h1.713V8.994h1.941a1.902 1.902 0 001.773-1.267H16.33z"
                fill="#37A72E"
            />
            <path
                d="M16.1 5.165c.1 1.27 1.294 2.275 2.75 2.275h2.977a1.907 1.907 0 00-1.85-2.275h-3.876z"
                fill="url(#prefix__paint0_linear_2723_9268)"
            />
            <path
                d="M13.565 7.408a.102.102 0 01.092-.054c.057 0 .1.046.102.1v3.355h1.713V5.165H13.76a.687.687 0 00-.553.366L11.844 8.48a.174.174 0 01-.014.035.115.115 0 01-.209-.066V5.165H9.908v5.644h1.713a.69.69 0 00.545-.366l1.4-3.026c-.004-.003 0-.006 0-.009zM7.17 7.506L6.168 10.81H4.935l-1-3.306a.111.111 0 00-.11-.092.112.112 0 00-.112.113v3.282H2V5.163h1.907a.82.82 0 01.737.55l.833 2.75c.043.137.109.134.152 0l.833-2.75a.816.816 0 01.737-.55h1.907v5.643H7.393V7.524 7.52a.112.112 0 00-.111-.113.117.117 0 00-.112.098z"
                fill="#37A72E"
            />
            <defs>
                <linearGradient
                    id="prefix__paint0_linear_2723_9268"
                    x1={16.101}
                    y1={6.303}
                    x2={21.861}
                    y2={6.303}
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#00A0E5" />
                    <stop offset={1} stopColor="#0077C3" />
                </linearGradient>
            </defs>
        </svg>
    );
}

export function UnionPayIcon({
    mainClassName,
}) {
    return (
        <svg
            width={24}
            height={16}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={mainClassName}
            viewBox="0 0 24 16"
        >
            <g clipPath="url(#prefix__clip0_2723_9267)">
                <rect width={24} height={16} rx={2} fill="#EBECEE" />
                <path
                    d="M19.542-3.781h9.879l-5.645 25.873h-9.88L19.543-3.78z"
                    fill="#0090A4"
                />
                <path
                    d="M-.166-3.781h9.879L4.067 22.092h-9.879L-.166-3.78z"
                    fill="#DD0228"
                />
                <path
                    d="M9.682-3.781h9.879l-5.645 25.873h-9.88L9.683-3.78z"
                    fill="#0057AB"
                />
                <path
                    d="M10.05 8.96h.1c.085 0 .147-.031.178-.087l.252-.376h.671l-.142.246h.801l-.104.377h-.955c-.11.166-.246.24-.406.234h-.499l.105-.395zm-.11.542h1.755l-.11.407h-.709l-.11.395h.69l-.111.413h-.69l-.16.586c-.037.099.012.142.154.13h.56l-.104.383h-1.078c-.203 0-.27-.118-.21-.352l.204-.746h-.437l.11-.408h.438l.104-.394h-.42l.124-.414zm2.808-1.011l-.025.24s.332-.246.634-.246h1.115l-.425 1.542c-.037.178-.185.265-.456.265H12.33l-.296 1.085c-.018.056.007.086.068.086h.246l-.092.34h-.628c-.24 0-.345-.075-.302-.223l.838-3.084h.585v-.005zm.941.437h-.99l-.118.413s.167-.117.443-.123c.277-.006.592 0 .592 0l.073-.29zm-.363.969c.074.012.118-.019.118-.086l.061-.222h-.991l-.086.308h.898zm-.67.493h.572l-.012.247h.154c.08 0 .117-.025.117-.074l.043-.16h.474l-.061.234c-.056.197-.197.296-.431.308h-.308v.426c-.006.067.055.104.185.104h.289l-.092.34h-.69c-.19.005-.289-.08-.283-.278l.042-1.147zM5.709 6.436c-.08.382-.259.672-.535.882-.277.203-.635.308-1.072.308-.412 0-.714-.105-.905-.315C3.061 7.163 3 6.972 3 6.744c0-.092.012-.198.037-.308l.468-2.252H4.2L3.74 6.411a.871.871 0 00-.019.173c0 .11.025.21.086.277.086.111.222.16.407.16a.875.875 0 00.535-.16.764.764 0 00.271-.45l.462-2.227h.702l-.474 2.252zM8.665 5.554h.554l-.43 2.01H8.24l.425-2.01zm.179-.734h.554l-.105.487H8.74l.105-.487zM9.706 7.41c-.142-.135-.215-.326-.215-.56 0-.043 0-.087.006-.136l.018-.148c.068-.327.203-.587.419-.777.215-.191.474-.29.776-.29.246 0 .443.068.585.21a.763.763 0 01.215.567c0 .043-.006.086-.006.142-.006.05-.012.099-.025.148a1.3 1.3 0 01-.418.765 1.121 1.121 0 01-.77.284c-.247 0-.444-.069-.585-.204zm1.053-.4c.098-.105.166-.265.209-.481l.018-.105c.007-.037.007-.068.007-.092a.42.42 0 00-.093-.29.347.347 0 00-.264-.105.492.492 0 00-.376.16c-.098.105-.166.272-.21.488l-.018.098c-.006.031-.006.062-.006.093 0 .123.03.216.092.283.062.068.154.099.271.099a.44.44 0 00.37-.148zM15.094 8.978l.136-.469h.671l-.03.173s.344-.173.59-.173h.832l-.13.469h-.13l-.627 2.208h.13l-.124.438h-.13l-.055.191h-.652l.055-.191h-1.287l.123-.438h.13l.628-2.208h-.13zm.727 0l-.173.598s.296-.11.542-.142c.055-.21.13-.456.13-.456h-.5zm-.253.876l-.172.629s.326-.16.548-.173c.061-.24.13-.45.13-.45h-.506v-.006zm.123 1.331l.13-.456h-.499l-.13.456h.5zm1.626-2.707h.634l.024.234c-.006.062.031.086.105.086h.11l-.11.395h-.462c-.178.006-.27-.061-.277-.203l-.024-.512zm-.185.851h2.044l-.123.426H18.4l-.11.394h.652l-.123.426h-.726l-.167.247h.358l.08.5c.012.049.055.073.129.073h.11l-.117.407h-.388c-.203.013-.307-.055-.313-.203l-.093-.457-.32.481c-.073.136-.19.198-.35.192h-.598l.117-.408h.185a.255.255 0 00.197-.104l.505-.734h-.653l.123-.426h.708l.11-.394h-.707l.123-.42zM6.362 5.548h.499l-.055.29.073-.08a.77.77 0 01.585-.26c.21 0 .358.062.456.186.092.124.117.29.074.512l-.271 1.369h-.51l.245-1.24c.025-.13.019-.222-.018-.283-.037-.062-.11-.092-.222-.092a.49.49 0 00-.332.123.603.603 0 00-.179.34L6.48 7.564h-.511l.393-2.017zM12.058 5.548h.499l-.055.29.067-.08a.774.774 0 01.591-.26c.21 0 .364.062.456.186.092.124.117.29.074.512l-.271 1.369h-.51l.245-1.24c.025-.13.019-.222-.018-.283-.043-.062-.11-.092-.222-.092a.49.49 0 00-.332.123.603.603 0 00-.179.34l-.227 1.152h-.511l.393-2.017zM14.521 4.308h1.441c.277 0 .492.062.64.185.148.124.222.302.222.537v.006c0 .043 0 .092-.006.148-.006.055-.019.11-.03.167a1.25 1.25 0 01-1.25 1.03h-.777l-.24 1.177h-.67l.67-3.25zm.358 1.511h.64c.166 0 .302-.037.394-.117.099-.08.16-.198.197-.358.006-.03.006-.055.013-.08 0-.025.006-.05.006-.068 0-.117-.043-.197-.124-.253-.08-.055-.209-.08-.388-.08h-.547l-.191.956zM19.83 7.947c-.21.45-.413.715-.536.839-.117.124-.357.401-.923.383l.049-.346c.474-.148.733-.808.88-1.104l-.172-2.165.37-.006h.307l.031 1.357.579-1.357H21l-1.17 2.4zM18.185 5.715l-.234.16c-.246-.191-.468-.308-.893-.11-.585.27-1.07 2.355.536 1.67l.092.111.634.019.42-1.894-.555.043zm-.363 1.036c-.104.302-.326.5-.505.444-.178-.055-.24-.346-.135-.648.104-.302.332-.5.505-.444.178.056.24.346.135.648z"
                    fill="#fff"
                />
            </g>
            <defs>
                <clipPath id="prefix__clip0_2723_9267">
                    <rect width={24} height={16} rx={2} fill="#fff" />
                </clipPath>
            </defs>
        </svg>
    );
}

export function VisaIcon({
    mainClassName,
}) {
    return (
        <svg
            width={24}
            height={16}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={mainClassName}
            viewBox="0 0 24 16"
        >
            <rect width={24} height={16} rx={2} fill="#EBECEE" />
            <path
                d="M10.02 10.9H8.51l.944-5.796h1.51L10.02 10.9zM7.24 5.104L5.801 9.09l-.17-.858-.508-2.607s-.061-.521-.716-.521h-2.38L2 5.202s.728.151 1.579.662L4.891 10.9h1.572l2.402-5.796H7.24zM19.114 10.9H20.5l-1.209-5.797h-1.213c-.56 0-.697.432-.697.432L15.13 10.9h1.573l.315-.861h1.92l.176.861zm-1.661-2.05l.793-2.17.446 2.17h-1.24zm-2.205-2.353l.215-1.244S14.8 5 14.106 5c-.75 0-2.529.327-2.529 1.919 0 1.497 2.088 1.516 2.088 2.303 0 .786-1.872.645-2.49.15l-.225 1.3s.674.328 1.704.328c1.03 0 2.584-.533 2.584-1.985 0-1.507-2.106-1.647-2.106-2.302 0-.656 1.47-.571 2.116-.216z"
                fill="#0049D8"
            />
            <path
                d="M5.631 8.232l-.508-2.607s-.061-.521-.716-.521h-2.38L2 5.202s1.144.237 2.24 1.124c1.05.849 1.391 1.906 1.391 1.906z"
                fill="#E6A540"
            />
        </svg>
    );
}


export function UnknownCardIcon({
    mainClassName,
}) {
    return (
        <svg
            width={24}
            height={16}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={mainClassName}
            viewBox="0 0 24 16"
        >
            <rect width={24} height={16} rx={2} fill="#C5CEDF" />
            <path fill="#DEE5F2" d="M0 3h24v4H0z" />
            <path fill="#A3AEC3" d="M2 10h7v1H2zM2 12h5v1H2z" />
        </svg>
    );
}


export function PlusIcon({
    mainClassName,
    strokeClassName,
}) {
    return (
        <svg
            width={18}
            height={18}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={mainClassName}
            viewBox="0 0 18 18"
        >
            <path
                d="M9 1v16M1 9h16"
                stroke="#505A72"
                strokeWidth={2}
                strokeLinecap="round"
                className={strokeClassName}
            />
        </svg>
    );
}


export function CrossDeleteIcon({
    mainClassName,
    strokeClassName,
}) {
    return (
        <svg
            width={8}
            height={8}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={mainClassName}
            viewBox="0 0 8 8 "
        >
            <path
                d="M7 1L4 4l3 3M1 1l3 3-3 3"
                stroke="#fff"
                strokeWidth={1.5}
                strokeLinecap="round"
                strokeLinejoin="round"
                className={strokeClassName}
            />
        </svg>
    );
}